var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from "classnames";
import React, { Children, useContext } from "react";
import LanguageContext from "./LanguageContext";
import PropTypes from "prop-types";
var LanguageBody = function (props) {
    // @ts-ignore
    var className = props.className, children = props.children, __TYPE = props.__TYPE, remaininProps = __rest(props, ["className", "children", "__TYPE"]);
    var context = useContext(LanguageContext);
    var modalSearchId = context.modalSearchId, modalSearchButtonId = context.modalSearchButtonId, modalMenuId = context.modalMenuId, modalMenuButtonId = context.modalMenuButtonId, isSearchOpen = context.isSearchOpen, onOpenSearch = context.onOpenSearch, isMenuOpen = context.isMenuOpen, onOpenNav = context.onOpenNav, enableNavigation = context.enableNavigation, enableSearch = context.enableSearch, enableLanguage = context.enableLanguage, enableLanguageList = context.enableLanguageList;
    var logoElement = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return child && child.props && child.props.__TYPE === "Logo";
    });
    var headerOperatorElement = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return child && child.props && child.props.__TYPE === "LanguagerOperator";
    });
    var headerServiceElement = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return child && child.props && child.props.__TYPE === "LanguageService";
    });
    var headerSearchBarElement = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return child && child.props && child.props.__TYPE === "SearchBar";
    });
    var headerToolsElement = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return child && child.props && child.props.__TYPE === "LanguageTools";
    });
    var switchLanguage = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return child && child.props && child.props.__TYPE === "LanguageList";
    });
    var searchClassNames = classNames("fr-header__search fr-modal", __TYPE, {
        "fr-modal--opened": isSearchOpen,
    });
    return (React.createElement("div", __assign({ className: "fr-header__body" }, remaininProps),
        React.createElement("div", { className: "fr-container" },
            React.createElement("div", { className: classNames(className, "fr-header__body-row") },
                React.createElement("div", { className: "fr-header__brand fr-enlarge-link" },
                    React.createElement("div", { className: "fr-header__brand-top" },
                        React.createElement("div", { className: "fr-header__logo" }, logoElement),
                        headerOperatorElement,
                        enableLanguageList ||
                            enableNavigation ||
                            (enableSearch && (React.createElement("div", { className: "fr-header__navbar" },
                                enableSearch && (React.createElement("button", { className: "fr-btn--search fr-btn", "data-fr-opened": isSearchOpen, "aria-controls": modalSearchId, id: modalSearchButtonId, title: "Rechercher", onClick: function () { return onOpenSearch(); } }, "Rechercher")),
                                enableNavigation && (React.createElement("button", { className: "fr-btn--menu fr-btn", "data-fr-opened": isMenuOpen, "aria-controls": modalMenuId, "aria-haspopup": "menu", id: modalMenuButtonId, title: "Menu", onClick: function () { return onOpenNav(true); } }, "Menu")))))),
                    headerServiceElement),
                React.createElement("div", { className: "fr-header__tools" },
                    headerToolsElement,
                    enableSearch && (React.createElement("div", { className: searchClassNames, id: modalSearchId },
                        React.createElement("div", { className: "fr-container fr-container-lg--fluid" },
                            React.createElement("button", { className: "fr-link--close fr-link", "aria-controls": modalSearchId, onClick: function () { return onOpenSearch(); } }, "Fermer"),
                            headerSearchBarElement))),
                    switchLanguage,
                    enableLanguage && (React.createElement("div", { className: searchClassNames, id: modalSearchId },
                        React.createElement("div", { className: "fr-collapse fr-translate__menu fr-menu" },
                            React.createElement("button", { className: "fr-link--close fr-link", "aria-controls": modalSearchId, onClick: function () { return onOpenSearch(); } }, "Fermer"),
                            headerSearchBarElement))))))));
};
LanguageBody.defaultProps = { __TYPE: "LanguageBody" };
LanguageBody.propTypes = { __TYPE: PropTypes.string };
export default LanguageBody;
